export const ORDER_STATUS = {
  DRAFT: 'DRAFT',
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  PAID: 'PAID',
  IN_REVIEW: 'IN_REVIEW',
  IN_PRODUCTION: 'IN_PRODUCTION',
  SHIPPED: 'SHIPPED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];


/** Nama cookie httpOnly yang menyimpan token keranjang tamu. */
export const CART_COOKIE_NAME = 'ci_cart';

/** Batas jumlah baris item dalam satu keranjang. */
export const MAX_CART_ITEMS = 50;

/** Umur keranjang tamu sejak aktivitas terakhir. */
export const CART_TTL_DAYS = 30;

/** Cookie access token, dikirim ke seluruh endpoint API. */
export const ACCESS_COOKIE_NAME = 'ci_at';

/** Cookie refresh token, dibatasi ke jalur /api/auth saja. */
export const REFRESH_COOKIE_NAME = 'ci_rt';

/** Jalur cookie refresh token. */
export const REFRESH_COOKIE_PATH = '/api/auth';

/** Batas jumlah alamat tersimpan per akun. */
export const MAX_ADDRESSES = 20;
